"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CarInfoCreditItem_1 = __importDefault(require("../CarInfoCreditItem"));
var CarInfoCredit = function (_a) {
    var leasingPayment = _a.leasingPayment, creditPayment = _a.creditPayment;
    var render = (react_1.default.createElement("div", { className: "azgazui__card-credit" },
        !!creditPayment && (react_1.default.createElement(CarInfoCreditItem_1.default, { label: "\u0432 \u043A\u0440\u0435\u0434\u0438\u0442 \u043E\u0442*", value: creditPayment })),
        !!leasingPayment && (react_1.default.createElement(CarInfoCreditItem_1.default, { label: "\u0432 \u043B\u0438\u0437\u0438\u043D\u0433 \u043E\u0442*", value: leasingPayment }))));
    return creditPayment || leasingPayment ? render : null;
};
CarInfoCredit.displayName = 'CarInfoCredit';
exports.default = CarInfoCredit;
